import { serialiseOccupancy } from './searchUtils'
import moment from 'moment'
import { validFlightDateRangeInMonths } from '../constants/flight'
import { last } from './arrayUtils'

interface FlightPriceKey {
  numberOfAdults: number;
  numberOfChildren: number;
  numberOfInfants: number;
  startDate: string;
  endDate: string;
  nights: number;
  origin: string;
  destination: string;
}

export function getFlightPriceKey(props: FlightPriceKey) {
  return `${props.numberOfAdults}-${props.numberOfChildren}-${props.numberOfInfants}-${props.startDate}-${props.endDate}-${props.nights}-${props.origin}-${props.destination}`
}

interface FlightKeyParams {
  startDate: string;
  endDate: string;
  origin: string;
  destination: string;
  currency: string;
  occupancies: Array<App.Occupants>;
  arrivalDate: string;
  fareClass: string;
  maxArrivalTime?: string;
  minReturningDepartureTime?: string;
  carriers?: Array<string>;
  fareType?: string;
  viewType?: string;
}

export function getFlightSearchKey(params: FlightKeyParams) {
  return [
    params.startDate,
    params.endDate,
    params.origin,
    params.destination,
    params.currency,
    serialiseOccupancy(params.occupancies),
    params.arrivalDate,
    params.fareClass,
    params.maxArrivalTime,
    params.minReturningDepartureTime,
    params.carriers?.join(','),
    params.fareType,
    params.viewType,
  ].join(':')
}

export function convertTimeObjectToMinutes(timeObject: { hours: number, minutes: number }) {
  return timeObject.hours * 60 + timeObject.minutes
}

export function convertTimeStringToMinutes(timeString: string) {
  const [hours, minutes] = timeString.split(':')

  return parseInt(hours, 10) * 60 + parseInt(minutes, 10)
}

export function isFlightDatesBetweenValidRange(startDate: string, endDate: string) {
  const now = moment()
  const duration = moment.duration(moment(startDate).diff(now)).asMonths()
  return (duration < validFlightDateRangeInMonths) && (!moment(startDate).isSame(endDate))
}

export function convertTimeV2StringToMinutes(dateTimeString: string) {
  const timeString = last(dateTimeString.split('-'))
  const [hours, minutes] = timeString.split(':')

  return parseInt(hours, 10) * 60 + parseInt(minutes, 10)
}
